<template>
  <!-- Renders nothing at all unless this is a Direct trial company admin:
       existing paid customers have memorised this UI and must not grow a
       surprise floating button (the same reason the prod FE is pinned). -->
  <div v-if="visible" class="setup-guide">
    <v-menu
      v-model="open"
      top
      offset-y
      :close-on-content-click="false"
      content-class="setup-guide-menu"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          class="setup-guide-fab"
          color="primary"
          dark
          rounded
          elevation="6"
          data-tour="setup-guide"
        >
          <v-icon left small>fa-map-signs</v-icon>
          Setup guide
          <span class="setup-guide-count">{{ doneCount }}/{{ chapters.length }}</span>
        </v-btn>
      </template>

      <v-card class="setup-guide-card">
        <div class="setup-guide-head">
          <div class="setup-guide-title">Setup guide</div>
          <div class="setup-guide-sub">
            Short tours of the real screens - take them in any order.
          </div>
        </div>
        <v-list dense class="py-0">
          <v-list-item
            v-for="chapter in chapters"
            :key="chapter.id"
            class="setup-guide-item"
          >
            <v-list-item-icon class="mr-3 my-auto">
              <v-icon v-if="isDone(chapter.id)" color="success" small
                >fa-check-circle</v-icon
              >
              <v-icon v-else color="grey lighten-1" small>fa-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ chapter.title }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ chapter.blurb }} · {{ chapter.minutes }} min
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn small text color="primary" @click="launch(chapter.id)">
                {{ actionLabel(chapter.id) }}
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import tour from "@/utils/tour";
import { chapterList } from "@/utils/tour/chapters";
import { extractTourChapters } from "@/utils/onboarding";
import { wizardLocked } from "@/utils/wizardLock";

export default {
  name: "SetupGuide",
  data() {
    return {
      open: false,
      chapters: chapterList(),
      chapterState: extractTourChapters(null)
    };
  },
  computed: {
    visible() {
      // tourActive() reads a reactive mirror, so the fab reappears the
      // instant the tour ends. Hidden too until the trial admin has finished
      // the Welcome to IMPROVE wizard: its chapters visit every admin page,
      // which would get around the locked menu.
      return (
        tour.canTour(this.$store.getters) &&
        !tour.tourActive() &&
        !wizardLocked()
      );
    },
    doneCount() {
      var self = this;
      return this.chapters.filter(function(c) {
        return self.isDone(c.id);
      }).length;
    }
  },
  watch: {
    // Reread persisted state whenever the menu opens - a tour may have
    // finished (or been resumed on another device) since the last look.
    open(val) {
      if (val) this.chapterState = extractTourChapters(null);
    },
    // ...and whenever the widget comes (back) into view: the fab hides while
    // a tour runs, and when it reappears after Done the count on the badge
    // must reflect the chapter that just completed - data() captured the
    // pre-tour state at mount and would otherwise show it until the menu
    // was opened.
    visible(val) {
      if (val) this.chapterState = extractTourChapters(null);
    }
  },
  methods: {
    isDone(id) {
      var st = this.chapterState[id];
      return !!(st && st.completed);
    },
    actionLabel(id) {
      var st = this.chapterState[id];
      if (st && st.completed) return "Replay";
      if (st && typeof st.step === "number" && st.step > 0) return "Resume";
      return "Start";
    },
    launch(id) {
      var self = this;
      this.open = false;
      tour.startChapter(id, {
        router: this.$router,
        storeGetters: this.$store.getters,
        onDone: function() {
          self.chapterState = extractTourChapters(null);
        }
      });
    }
  }
};
</script>

<style scoped>
.setup-guide-fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 8;
  text-transform: none;
  letter-spacing: 0;
}

.setup-guide-count {
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.25);
  font-size: 11px;
}

.setup-guide-card {
  width: 380px;
  max-width: 92vw;
}

.setup-guide-head {
  padding: 14px 16px 10px;
  border-bottom: 1px solid #eef1f4;
}

.setup-guide-title {
  font-size: 15px;
  font-weight: 600;
}

.setup-guide-sub {
  font-size: 12px;
  color: #7a8794;
  margin-top: 2px;
}

.setup-guide-item {
  border-bottom: 1px solid #f4f6f8;
}

.setup-guide-item:last-child {
  border-bottom: none;
}
</style>
